import React, { useState, useEffect } from 'react';
import { 
  DeleteForever 
} from '@mui/icons-material';

import FabButton from "@components/input/buttons/FabButton";
import { Button } from '@mui/material';
// import MyMuiButton from './MyMuiButton';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function DeleteButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <DeleteForever/>
      </FabButton>
    );
  } else {
    return (
      <Button 
        className={className}
        disabled={disabled} 
        onClick={onClick}
        variant="contained" color="primary">
        <DeleteForever/>&nbsp;{ label }
      </Button>
    );
  }
}
